/**
 * Spinner
 */

export function spinner() {

    // Show
    var create = function (elId, elAppendedTo) {
        var elem = document.createElement('div');
        var id = 'spinner';
        var appendedEl = document.body;

        if (elId != undefined && elId != null && elId != '') {
            id = elId;
        }
        elem.setAttribute('id', id);
        elem.innerHTML =
            '<div class="spinner-circle">' +
            '<svg class="circle__svg" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">' +
            '<circle class="circle__svg-circle" cx="50" cy="50" r="45"/>' +
            '</svg>' +
            '</div>';

        if (elAppendedTo != undefined && elAppendedTo != null && elAppendedTo != '') {
            appendedEl = elAppendedTo;
        }

        appendedEl.appendChild(elem)
        show(elem, id)
    };

    var show = function (elem, elId) {
        // elem.className += 'show'
        var id = 'spinner';
        if (elId != undefined && elId != null && elId != '') {
            id = elId;
        }
        var el = document.getElementById(id);
        if (el) {
            el.classList.add('show');
        }
    };

    // Hide
    var hide = function (elId) {
        var id = 'spinner';
        if (elId != undefined && elId != null && elId != '') {
            id = elId;
        }
        var el = document.getElementById(id);
        if (el) {
            el.classList.remove('show');
        }
    };

    return {
        create: create,
        show: show,
        hide: hide
    }
}

export default spinner
